import React from 'react';
import styled from 'styled-components';
import DividerSVG from '@Assets/Svgs/divider_0.5.svg';
import AddImage from '@Assets/Images/ic_add.png';
import {
  addEmptyProcesses,
  addPageBetweenProcesses,
  useEditor,
  addEmptyProcessesHighLight,
  resetHilightProcess,
} from '@Services/Editor';
import { useDispatch, useSelector } from 'react-redux';
import { setTriggerResize } from '@Services/CommonStatus';
import { useTriggerResizeSelector } from '@Services/CommonStatus/Selector';

const Divider = ({
  isHovered,
  handleMouseEnter,
  handleMouseLeave,
  processId,
  scrollToTargetProcess,
  setPage,
  snackBarRef,
}) => {
  const dispatch = useDispatch();
  const { processes } = useSelector(useEditor);
  const { resizeTrigger } = useSelector(useTriggerResizeSelector);

  const scollWithHighlight = targetProcessId => {
    setPage(prevPage => prevPage + 1);
    setTimeout(() => {
      scrollToTargetProcess(targetProcessId + 1);
      dispatch(addEmptyProcessesHighLight({ processId: targetProcessId }));
      setTimeout(() => {
        dispatch(resetHilightProcess());
      }, 1000); // 1초 후에 resetHilightProcess 액션 디스패치
    }, 500); // 500 milliseconds = 0.5 seconds
  };
  const addPageFuc = () => {
    const findLastPageId = processes[processes.length - 1].processId;

    if (processes?.length >= 500) {
      snackBarRef.current.show({
        text: '페이지는 최대 500개까지 생성 가능합니다.',
      });

      return;
    }

    const findTargetPageIdProcess = processes.find(process => process.processId === Number(processId));

    if (findLastPageId === processId) {
      dispatch(addEmptyProcesses());
      if (findTargetPageIdProcess && typeof findTargetPageIdProcess.processId === 'number') {
        // Check if processId is 19, 39, 59, etc.

        if ((findTargetPageIdProcess.processId + 1) % 20 === 0) {
          scollWithHighlight(findTargetPageIdProcess.processId);
        }
      }
      return;
    }
    dispatch(setTriggerResize({ resizeTriggerBoolean: !resizeTrigger }));
    dispatch(addPageBetweenProcesses({ processId }));

    if (findTargetPageIdProcess && typeof findTargetPageIdProcess.processId === 'number') {
      // Check if processId is 19, 39, 59, etc.
      if ((findTargetPageIdProcess.processId + 1) % 20 === 0) {
        scollWithHighlight(findTargetPageIdProcess.processId);
      }
    }
  };

  // const addPageFuc = () => {
  //   const findLastPageId = processes[processes.length - 1].processId;

  //   if (processes?.length >= 500) {
  //     snackBarRef.current.show({
  //       text: '페이지는 최대 500개까지 생성 가능합니다.',
  //     });

  //     return;
  //   }

  //   if (findLastPageId === processId) {
  //     dispatch(addEmptyProcesses());
  //     return;
  //   }

  //   dispatch(addPageBetweenProcesses({ processId }));

  //   const findTargetPageIdProcess = processes.find(process => process.processId === Number(processId));

  //   if (findTargetPageIdProcess && typeof findTargetPageIdProcess.processId === 'number') {
  //     // Check if processId is 19, 39, 59, etc.
  //     if ((findTargetPageIdProcess.processId + 1) % 20 === 0) {
  //       setPage(prevPage => prevPage + 1);
  //       setTimeout(() => {
  //         scrollToTargetProcess(findTargetPageIdProcess.processId + 1);
  //       }, 500); // 500 milliseconds = 0.5 seconds
  //     }
  //   }
  // };

  return isHovered ? (
    <DevidderContainer onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <PageAddButtonContainer onClick={addPageFuc}>
        <AddPageIcon />
        <span>페이지 추가</span>
      </PageAddButtonContainer>
      <DividerLine />
    </DevidderContainer>
  ) : (
    <DummyDiv onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} />
  );
};

const DummyDiv = styled.div`
  position: relative;
  width: 100%;
  height: 32px;
`;

const DevidderContainer = styled.div`
  position: relative;
  width: 100%;
  height: 32px;
`;

const PageAddButtonContainer = styled.div`
  display: inline-flex;
  height: 32px;
  padding: 6px 12px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 23px;
  border: 1px solid var(--ui_3, #e9e9eb);
  background: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  span {
    color: var(--ui_on_1, #0a0a0a);
    font-family: Pretendard;
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px; /* 123.077% */
    letter-spacing: -0.3px;
  }
`;

const AddPageIcon = styled.img.attrs({
  src: AddImage,
  alt: '페이지 사이 추가',
})`
  width: 16px;
  height: 16px;
  margin-right: 8px;

  /* margin-right: 14px; */
`;

const DividerLine = styled.img.attrs({ src: DividerSVG })`
  height: 2px;
  top: 0;
  width: 100%;
  user-select: none;
  stroke: 1px solid ${({ theme }) => theme.colors.ui_4};
`;

export default Divider;

// import React from 'react';
// import styled from 'styled-components';
// import DividerSVG from '@Assets/Svgs/divider_0.5.svg';

// const Divider = () => {
//   return <DividerLine />;
// };

// const DividerLine = styled.img.attrs({ src: DividerSVG })`
//   height: 2px;
//   top: 0;
//   width: 100%;
//   user-select: none;
//   stroke: 1px solid ${({ theme }) => theme.colors.ui_4};
// `;

// export default Divider;
